<!--
 * @Author: RYL
 * @Description: 
 * @Date: 2020-07-16 16:52:43
 * @LastEditTime: 2020-10-15 15:59:09
-->
<template>
  <div>
    <!-- 概览 -->
    <div class="title">{{$t('lang.particulars.GeneralInfo')}}</div>
    <general-info :list="list" :SsPsShow="SsPsShow" @showDeviceDetail="showDeviceDetail"></general-info>
    <!-- 状态信息 -->
    <div class="title">{{$t('lang.particulars.StateManager')}}</div>
    <status-info :list="list" @showDeviceDetail="showDeviceDetail"></status-info>
  </div>
</template>
<script>
import { showDeviceDetail, updateDevice } from "@/api/particulars";
import generalInfo from './generalInfo'
import statusInfo from './statusInfo'
export default {
  props: ['list', 'SsPsShow'],
  components: {
    generalInfo,
    statusInfo,
  },
  data() {
    return {
      //设备名称与设备地址修改
      DeviceInfo:{
        show:false,
        deviceName:'',
        id:'',
        deviceAddress:''
      },
    }
  },
  methods: {
    //修改设备名称与设备地址
    DeviceInfoShow(){
      this.DeviceInfo.show=true
      this.DeviceInfo.deviceAddress=this.list.deviceAddress
      this.DeviceInfo.deviceName=this.list.deviceName?this.list.deviceName:''
      this.DeviceInfo.id=this.list.deviceId
    },
    UpDeviceNameAndAddress(){
      updateDevice(this.DeviceInfo.id,this.DeviceInfo.deviceName,this.DeviceInfo.deviceAddress)
      .then((res)=>{
        if (res.data.code === 0) {
              this.$message({
                showClose: true,
                message: this.$t("lang.particulars.message15"),
                type: "success"
              });
              this.DeviceInfo.show=false
              this.$emit('showDeviceDetail')
            } else {
              this.$message({
                showClose: true,
                message: this.$t("lang.particulars.message16"),
                type: "warning"
              });
            }
      })
    },
    showDeviceDetail(){
       this.$emit('showDeviceDetail')
    }
  }
}
</script>
<style scoped>
.title{
  margin-top: 15px;
  margin-bottom: 10px;
  font-size: 15px;
  font-weight: bold;
}
</style>
